import bsfcuBranch from "./bsfcu-branch.png";
import fcfcuBranch from "./fcfcu-branch.png";
import fcfcuAtm from "./fcfcu-atm.png";
import networkAtm from "./network-atm.png";
import sharedBranch from "./shared-branch.png";

export const getLocationType = (location, t) => {
  if (location.shared) {
    // Pull coop or atm
    return location.hasBranch
      ? {
          label: t("locations.sharedBranch"),
          pinImage: sharedBranch,
        }
      : {
          label: t("locations.networkAtm"),
          pinImage: networkAtm,
        };
  } else {
    if (location.hasBranch) {
      return location.mapIconInfo == "bsfcu"
        ? {
            label: t("locations.bsfcuBranch"),
            pinImage: bsfcuBranch,
          }
        : {
            label: t("locations.fcfcuBranch"),
            pinImage: fcfcuBranch,
          };
    } else {
      return {
        label: t("locations.fcfcuAtm"),
        pinImage: fcfcuAtm,
      };
    }
  }
};



// WEBPACK FOOTER //
// ./src/locator/types/index.js